import {
  createRootRoute,
  createRoute,
  createRouter,
  lazyRouteComponent,
} from '@tanstack/react-router'
import RootLayout from './components/layout/RootLayout'
import IndexPage from './pages/IndexPage'
import MarkdownPage from './pages/MarkdownPage'
import CheatsheetPage from './pages/CheatsheetPage'
import NotFoundPage from './pages/NotFoundPage'

const rootRoute = createRootRoute({
  component: RootLayout,
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})

const changelogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/changelog',
  component: () => <MarkdownPage pageSlug="changelog" />,
})

const cheatsheetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cheatsheet/$slug',
  component: CheatsheetPage,
})

const playgroundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/playground',
  component: lazyRouteComponent(() => import('./pages/PlaygroundPage')),
})

const routeTree = rootRoute.addChildren([
  indexRoute,
  changelogRoute,
  cheatsheetRoute,
  playgroundRoute,
])

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFoundPage,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
